<template>
    <div class="as-radio" @click="onClick" :class="value ? 'selected' : ''">
        <div class="as-radio__label">{{label}}</div>
        <div class="as-radio__button"></div>
    </div>
</template>
<script>
    export default {
        name: 'AsRadio',
        props:{
            label: String,
            default: String
        },
        data(){
            return {
                value: false
            }
        },
        methods:{
            onClick() {
                this.value = !this.value;
                this.$emit('change',this.value);
            }
        },
        mounted() {
            this.value = this.default;
        }
    }
</script>

<style lang="scss">
.as-radio {
    display: inline-block;
    height: 30px;
    padding:0 5px;
    line-height: 30px;
    border-radius: 4px;
    background-color: #FFF;
    font-size: 12px;
}
.as-radio:hover{
    box-shadow: rgba(0,0,0,0.3) 1px 1px 3px;
}
.as-radio__label {
    float: left;
    margin: 0 5px;
    cursor: pointer;
}
.as-radio__button {
    float: left;
    height: 20px;
    width: 42px;
    margin: 5px;
    border-radius: 10px;
    background-color: #C0C0C0;
}
.as-radio__button::before{
    content: "";
    float: left;
    height: 16px;
    width: 16px;
    margin:2px;
    border-radius: 8px;
    background-color: #FFF;
    position: relative;
    left: 0;
    transition:left 0.2s ease-in;
}
.as-radio.selected .as-radio__button{
    background-color: #B177B4;
}
.as-radio.selected .as-radio__button::before{
    left: 22px;
}
</style>